import request from '@/utils/request'

let SmsApi = {
  /*获取发送任务列表*/
  taskList(data) {
    return request._post('/shop/plus.data.sms/index', data);
  },

 /*删除发送任务*/
 del(data,cancel) {
  return request._post('/shop/plus.data.sms/del', data);
},
 /*修改发送任务*/
 edit(data,cancel) {
  return request._post('/shop/plus.data.sms/edit', data);
},
 /*新增发送任务*/
 add(data,cancel) {
  return request._post('/shop/plus.data.sms/add', data);
},

 /*获取设置*/
 getSetting(data) {
  return request._get('/shop/plus.data.sms/setting', data);
},
/*保存设置*/
saveSetting(data) {
  return request._post('/shop/plus.data.sms/setting', data);
},
}
export default SmsApi;



// WEBPACK FOOTER //
// ./src/api/sms.js